import { ContactEntity } from '@/entities/api/contact/contact'
import { API_URL, CUSTOMERS_KEY } from '../keys'
import axios from 'axios'

const BASE_URL = `${API_URL}/contact`

const defaultHeaders = {
	'sce-api-key': CUSTOMERS_KEY,
	'Content-Type': 'application/json',
}

const defaultConfig = {
	headers: defaultHeaders,
	validateStatus: (status: number) => status < 500,
}

export const createContact = async (data: ContactEntity) => {
	const response = await axios.post(BASE_URL, data, defaultConfig)
	if (response) return response
}
